module.exports = __webpack_public_path__ + "img/icon-sb-shop-the-collection-boutique-48x48.3f52e8d.svg";